export default ({driver: {first_name = ''} = {}} = {}) => first_name;
